import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { SnackbarActions, GlobalLoaderActions } from 'actionsets'
import Button from '@material-ui/core/Button'
import LinkedInXS from 'img/linkedin-xs.png'
import { LinkedInService } from '../../services'
import StyleSheet, { AppStyles } from 'styles'

export class LinkedIn extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onAuthorized: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    SnackbarActions.bindActions(this, 'snackbar')
    GlobalLoaderActions.bindActions(this, 'loader')
  }

  authorizationCallback = async authHash => {
    let {error, errorDescription, authCode, redirectUri} = authHash

    if(error) {
      this.actions.snackbar.error(`Failed to retrieve LinkedIn authorization code. ${errorDescription}`)
    } else {
      this.actions.snackbar.success('LinkedIn authorization code retrieved.')
      this.actions.loader.startLoad()
      try {
        await this.props.onAuthorized({ authCode, redirectUri })
      }finally{
        this.actions.loader.stopLoad()
      }
    }
  }

  authorize = () => {
    LinkedInService.authorize(this.authorizationCallback)
  }

  render = () => {
    return(
      <Button variant='contained' color="primary" onClick={this.authorize} className={[AppStyles.link, styles.linkedinButton, this.props.className].join(' ')}>
        <img alt={this.props.label} src={LinkedInXS} style={{marginRight: 10}}/><span style={{marginTop: 2}}>{this.props.label}</span>
      </Button>
    )
  }
}

const styles = StyleSheet({
  linkedinButton: {
    background: '#007ab9',
    textDecoration: 'none',
    padding: 10,
    flex: 1,
    '& button': {
      width: '100%',
      padding: '0 8px'
    },
    '&:hover': {
      backgroundColor: '#0695e0'
    }
  },
})

export default connect()(LinkedIn)